import { hapticFeedback } from "@tma.js/sdk-react"
import { useCallback } from "react"

export function useHaptic() {
	const triggerHaptic = useCallback((type: "light" | "medium" | "heavy" = "light") => {
		if (hapticFeedback.impactOccurred.isAvailable()) {
			hapticFeedback.impactOccurred(type)
		}
	}, [])

	const triggerNotification = useCallback((type: "success" | "warning" | "error") => {
		if (hapticFeedback.notificationOccurred.isAvailable()) {
			hapticFeedback.notificationOccurred(type)
		}
	}, [])

	const triggerSelection = useCallback(() => {
		if (hapticFeedback.selectionChanged.isAvailable()) {
			hapticFeedback.selectionChanged()
		}
	}, [])

	return { triggerHaptic, triggerNotification, triggerSelection }
}
